const BASE = 'PAYMENTS';

export const INITIALIZE = `${BASE}:INITIALIZE`;
export const INITIALIZE_DETAILS = `${BASE}:INITIALIZE_DETAILS`;
export const LOAD_PAYMENTS = `${BASE}:LOAD_PAYMENTS`;
export const LOAD_PAYMENT_DETAILS = `${BASE}:LOAD_PAYMENT_DETAILS`;
export const LOAD_TRANSACTIONS = `${BASE}:LOAD_TRANSACTIONS`;
